import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Space, Button, Row, Col, Typography, Form, message, Spin } from 'antd';
import InputForm from '../components/InputForm';
import { useForm } from 'react-hook-form';
import { getKitchenQueue } from "../../ducks/actions";
import { editKitchenQueue } from "../../ducks/services";
import { useDispatch, useSelector } from 'react-redux';
import AllRoles from '../../../../../routing/config/AllRoles';
import { allowed } from '../../../../../routing/config/utils';
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title, Text } = Typography;

export default (props) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { control, handleSubmit, formState: { errors }, setValue } = useForm();
  const data = useSelector((state) => state.pos.kitchenQueue);
  const meta = useSelector((state) => state.pos.kitchenQueueOption);
  const allowedEdit = allowed([AllRoles.POS.KITCHEN_QUEUE], 'write');
  const i18n = useTranslate();
  const { t } = i18n;

  useEffect(() => {
    dispatch(getKitchenQueue(id, props.setLoading));
  }, []);

  useEffect(() => {
    if(data && 'id' in data) {
      setValue('code', data.code);
      setValue('desc', data.desc);
      setValue('kitchen_display', data.display_mode ? { label: data.display_mode, value: data.display_mode } : '');
      setValue('kitchen_queue_type', data.kitchen_queue_type ? { label: data.kitchen_queue_type, value: data.kitchen_queue_type } : '');
      setValue('slip_settings', data.slip_settings ? { label: data.slip_settings, value: data.slip_settings } : '');
      setValue('slip_print_mode', data.slip_print_mode ? { label: data.slip_print_mode, value: data.slip_print_mode } : '');
      setValue('is_readonly', data.is_readonly == "1");
    }
  }, [data])

  const onFinish = async (val) => {
    props.setLoading(true);

    const payload = {
      code: val.code,
      desc: val.desc,
      kitchen_queue_type: val?.kitchen_queue_type?.value,
      display_mode: val?.kitchen_display?.value,
      slip_settings: val?.slip_settings?.value,
      slip_print_mode: val?.slip_print_mode?.value,
      kitchen_queue_id: id,
      is_readonly: val?.is_readonly ? 1 : 0,
    }
    await editKitchenQueue(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_kitchen_queue"));
        setTimeout(() => navigate("/pos/kitchen-queue"), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col flex='auto'>
              <Title level={3} className='mb-0 mt-0'>{data?.code}</Title>
            </Col>
            <Col flex='auto' className='text-right'>
              <Space size={10}>
                {
                  allowedEdit &&
                  <Button size="large" htmlType='submit' className='green-btn'>{t("General.save")}</Button>
                }
                <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/pos/kitchen-queue')}>{'<'} {t("General.back")}</Button>
              </Space>
            </Col>
          </Row>
        </Col>
        <InputForm
          control={control}
          errors={errors}
          meta={meta}
          allowedEdit={allowedEdit}
        />
      </Row>
    </Form>
  )
}